import { TableCell } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import FormTextInputTranslatable from 'components/FormTextInput/FormTextInputTranslatable';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import {
  isTranslatableLangIdenticalInTwoObjects,
  useTranslatableSelectedLanguage,
  isTranslatableLangEmpty,
  compareTranslatableValues,
  TranslatableObjectKey,
} from 'hooks/redux/Translatable/useTranslatableLanguages';

import { useSizeNameOverride } from '../../contexts/SizeNameOverridesContext';

const SizeNameCell = ({
  dish,
  size,
  dishSizes,
  handleSizeNameChange,
  copyMode,
}) => {
  const { t } = useTranslation();
  const lang = useTranslatableSelectedLanguage();

  const dishSizeBySize = dishSizes.find(
    dishSize => dishSize.size === size?.['@id']
  );

  const [isOverriddenByUser, setIsOverriddenByUser] = useSizeNameOverride(
    `${dishSizeBySize.mealType['@id']}_${dishSizeBySize.size}`
  );

  const sizeNameTranslations =
    dishSizeBySize.name?.[TranslatableObjectKey] ?? {};

  const isNameFollowingDishName = Object.keys(sizeNameTranslations)
    .filter(
      translatedLang =>
        !isTranslatableLangEmpty(dishSizeBySize.name, translatedLang)
    )
    .every(
      translatedLang =>
        isTranslatableLangIdenticalInTwoObjects(
          dishSizeBySize.name,
          dish.nameForClientInitial,
          translatedLang
        ) ||
        isTranslatableLangIdenticalInTwoObjects(
          dishSizeBySize.name,
          dish.nameForClient,
          translatedLang
        )
    );

  const isDefault = isNameFollowingDishName && !isOverriddenByUser;

  const onToggleIsDefault = () => {
    const isNewStateDefault = !isDefault;

    if (!copyMode) {
      handleSizeNameChange(
        isNewStateDefault
          ? null
          : {
              [TranslatableObjectKey]: {
                ...sizeNameTranslations,
                [lang]: dish.nameForClient?.[TranslatableObjectKey]?.[lang],
              },
            },
        dishSizeBySize
      );
    }

    setIsOverriddenByUser(!isNewStateDefault);
  };

  return (
    <TableCell>
      <LabeledCheckbox
        checked={isDefault}
        onChange={onToggleIsDefault}
        label={t('mealTypes.default.fem', 'Domyślna')}
      />
      {!isDefault && (
        <FormTextInputTranslatable
          formControlProps={{ fullWidth: true }}
          maxLength={160}
          value={dishSizeBySize.name ?? { [TranslatableObjectKey]: {} }}
          handleChange={e => {
            if (
              !compareTranslatableValues(e.target.value, dishSizeBySize.name)
            ) {
              handleSizeNameChange(e.target.value, dishSizeBySize);
            }
          }}
        />
      )}
    </TableCell>
  );
};

export default SizeNameCell;
